import { useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import { BuyerOptionProps, isGroupBuyerOptionValues } from '.';
import { FormLabel, FormControl, MenuItem, OutlinedInput, ListItemText, Select, SelectChangeEvent} from '@mui/material';
import LinkifyText from '../../common/LinkifyText';


export default function MultipleSelectCheckmarks(props: BuyerOptionProps) {
  const checkboxOptionVals = isGroupBuyerOptionValues(props.value) ? props.value : undefined;
  const options = checkboxOptionVals ? checkboxOptionVals.options : [''];

  const [selectedValues, setSelectedValues] = useState<string[]>(
    props.currentValue ? (typeof props.currentValue === 'string' ? props.currentValue.split(',') : [props.currentValue]) : []
  );

  const handleChange = (event: SelectChangeEvent<typeof selectedValues>) => {
    const {
      target: { value },
    } = event;
    const newValues = typeof value === 'string' ? value.split(',') : value;
    setSelectedValues(newValues);

    if (props.onDetailChange) {
      props.onDetailChange(
        props.optionKey,
        newValues.join(','),
        props.isEditMode ? props.buyerDetailId : props.id
      );
    }
  };

  return (
    <FormControl 
      required={props.isRequired} 
      disabled={props.isDisabled}
      sx={{ m: 1, width: 300 }}
    >
      <FormLabel sx={{ pb: 1 }}>
        <LinkifyText text={props.label} />
      </FormLabel>
      <Select
        multiple
        displayEmpty
        value={selectedValues}
        onChange={handleChange}
        input={<OutlinedInput />}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <span style={{ color: 'gray' }}>Select options...</span>;
          }
          return selected.join(', ');
        }}
        disabled={props.isDisabled}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            <Checkbox checked={selectedValues.includes(option)} />
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
